export default __webpack_public_path__ + "static/media/2505-00.d07db135.jpg";